module.exports = __webpack_public_path__ + "img/dropoff-pin.26555b48.svg";